import { NextRequest } from "next/server"

/** Dispara o middleware, revalidando regras no lado runtime do servidor. */
export async function runMiddleware() {
    const response = await fetch('/', {
        headers: {
            'x-refresh-token': 'true',
            'Cache-Control': 'no-cache',
            'User-Agent': 'FetchMiddlewareFromClient/1.0',
        }
    })

    return response
}

export function getDomain(request: NextRequest) {
    let domain = request.headers.get("host")?.split('.')[0]

    if (!domain || domain.includes("localhost")) {
        const { searchParams } = new URL(request.url)
        domain = searchParams.get("url") ?? undefined
    }

    return domain
}

export function getSocialAuthUrl(socialCookie: string, hostname: string) {
    const data = JSON.parse(socialCookie)

    let baseUrl = `https://${data.subdomain}.${hostname}`

    if (data.subdomain.includes('--selfdomain'))
        baseUrl = decodeURIComponent(data.subdomain.replace('--selfdomain', ''))

    if (data.redirect)
        baseUrl += `/${data.redirect}`

    const params = `?accessToken=${data.accessToken}&refreshToken=${data.refreshToken}`

    return baseUrl + params
}